import React from 'react';
import { Card } from 'react-bootstrap';

const Error500 = () => (
  <Card className="text-center h-100">
    <Card.Body className="p-5">
      <div className="display-1 text-300 fs-error">500</div>
      <p className="lead mt-4 text-800 font-sans-serif fw-semibold">
        Ops, algo deu errado!
      </p>
      <hr />
      <p>
        Tente recarregar a página, ou tente voltar e realize a ação novamente.
        Se esse erro persistir,
        <a href="mailto:contato@mspworks.com.br" className="ms-1">
          contate-nos
        </a>
        .
      </p>
    </Card.Body>
  </Card>
);

export default Error500;
